import { createServer } from 'miragejs'
import appConfig from 'configs/app.config'

import { signInUserData } from './data/authData'
import { centralBankList, regionalBankList, insuranceCompanyList } from './data/commonData'
import { datapolisRecords, datapolisLogs, datapolisDocuments } from './data/datapolisData'
import { claimRecords, claimNotes } from './data/claimData'
import {
    accountFormData, formStatus, dataProfesi, databaseProfesi,
    dataKetentuanMedis, dataTarifPremi, dataPersyaratanKlaim,
    dataTemplate, dataPKS, dataBiaya, dataPenerbitanPolis
} from './data/konfigurasiData'

import {
    authFakeApi, konfigurasiFakeApi, commonFakeApi,
    datapolisFakeApi, dashboardFakeApi, claimFakeApi, financeFakeApi
} from './fakeApi'

// Use the same API URL as BaseService to ensure route matching
const API_URL_BY_ENV = {
    development: appConfig.apiDevPrefix,
    production: appConfig.apiPrefix,
}
const apiBase = API_URL_BY_ENV[process.env.REACT_APP_API_ENV] || appConfig.apiPrefix

export default function mockServer({ environment = 'test' }) {
    return createServer({
        environment,
        seeds(server) {
            server.db.loadData({
                // Auth
                signInUserData,
                // Common
                centralBankList,
                regionalBankList,
                insuranceCompanyList,
                // Datapolis
                datapolisRecords,
                datapolisLogs,
                datapolisDocuments,
                // Claims
                claimRecords,
                claimNotes,
                // Konfigurasi
                accountFormData,
                formStatus,
                dataProfesi,
                databaseProfesi,
                dataKetentuanMedis,
                dataTarifPremi,
                dataPersyaratanKlaim,
                dataTemplate,
                dataPKS,
                dataBiaya,
                dataPenerbitanPolis,
            })
        },
        routes() {
            // Set urlPrefix to the API base URL so MirageJS properly intercepts requests
            this.urlPrefix = apiBase
            this.namespace = ''
            this.passthrough()

            // Pass empty string since urlPrefix handles the base URL
            authFakeApi(this, '')
            konfigurasiFakeApi(this, '')
            commonFakeApi(this, '')
            datapolisFakeApi(this, '')
            dashboardFakeApi(this, '')
            claimFakeApi(this, '')
            financeFakeApi(this, '')
        },
    })
}
